import {AfterContentInit, Component, EventEmitter, ViewChild} from '@angular/core';
import {ApDynComponentComponent}                              from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                                             from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                             from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {IApPermissionData, IGridData, IWizardChoiceData}      from '../../ap-interface/interfaces';
import {
  ApDynGridStatusColumnConfig
}                                                             from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig
}                                                             from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridEditColumnConfig
}                                                             from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {ApDynGridPagerConfig, IGridPagerSubmitData}           from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {ApGridPagerType}                                      from '../../ap-interface';
import {ApPermissions}                                        from 'invoker-transport';
import {
  ApSubFarmsEditComponent
}                                                             from '../../entry-components/ap-basedata-entry-components/ap-subfarms-edit.component';
import {filter, map}                                          from 'rxjs/operators';
import {SubFarmStore}                                         from '../../stores/base-data/subfarm.store';
import {AccessPermissionsStore}                               from '../../stores/settings/access.permission.store';
import {FarmUsersStore}                                       from '../../stores/farm/farm.users.store';
import {FormStore}                                            from '../../stores/layout/form.store';
import {MapViewStore}                                         from '../../stores/layout/mapview.store';
import {TranslationStore}                                     from '../../stores/translation/translation.store';
import {GetPermissionPipe}                                    from '../../ap-permission/pipes/get-permission.pipe';
import ISubFarms = Data.BaseData.ISubFarms;

interface ISubFarmGridData extends IGridData<ISubFarms> {
  Status: number;
  StatusClass: string;
  StatusDesc: string;
}

/**
 * Component for the sub farms
 */
@Component({
  selector: 'ap-subfarms-overview',
  template: `
    <ap-dyncomponent [caption]="'Docu_Ini__Corporates'"
                     [canSearch]="true"
                     [headerIcon]="'ap-basedata-icon'"
                     [filterTooltip]="'filterTooltip'"
                     [columns]="columns"
                     [items]="items$ | async"
                     [loading$]="subFarmsLoading$"
                     [pager]="pager"
                     [groupable]="true"
                     (create)="onCreate()"
                     (edit)="onEdit($event)"
                     [canCreate]="(ApPermissions.EDIT_SUBFARMS | getPermission | async)"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
    ></ap-dyncomponent>`
})

export class ApSubFarmsComponent implements AfterContentInit {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  columns: ApDynGridColumnConfigBase[] = [];
  public subFarmsLoading$ = this.subFarmStore.Listen(s => s.loading);
  public items$ = this.subFarmStore.Listen(s => s.data).pipe(
    filter(d => !!d),
    map(d => d.Convert<ISubFarmGridData>(subFarm => ({
      Id: subFarm.Id,
      SourceItem: subFarm,
      Status: subFarm.DeletedBy !== null ? -1 : 1,
      StatusClass: subFarm.DeletedBy !== null ? 'ap-status-red' : 'ap-status-green',
      StatusDesc: subFarm.DeletedBy !== null ? 'AgriConnect_Deleted' : 'Global__Active',
    }))),
  );
  pager: ApDynGridPagerConfigBase;
  public ApPermissions = ApPermissions;
  public apPermissionData: IApPermissionData;
  private _listMassEditing = [];
  private _onDelete = new EventEmitter();

  constructor(private subFarmStore: SubFarmStore,
              private translationStore: TranslationStore,
              private mapViewStore: MapViewStore,
              private farmUsersStore: FarmUsersStore,
              private permissionsStore: AccessPermissionsStore,
              private permissionPipe: GetPermissionPipe,
              private formStore: FormStore) {
    this.mapViewStore.hideMapView();
    this._onDelete.subscribe((event) => this.deleteClicked(event));
  }

  ngAfterContentInit(): void {
    this.getDataFromStore();
    this.gridBuilder();
    this.fillWizardChoiceData();
  }

  getDataFromStore(): void {
    this.subFarmStore.loadSubFarms();
  }

  onCreate(): void {
    this.formStore.openForm({component: ApSubFarmsEditComponent, data: null});
  }

  onEdit(dataItem): void {
    this.formStore.openForm({component: ApSubFarmsEditComponent, data: dataItem.SourceItem});
  }

  deleteClicked(event: IGridPagerSubmitData): void {
    event.ids.forEach(id => {
      const item = this.subFarmStore.Listen(s => s.data).getValue().Find(i => i?.Id === id);
      if (item) {
        this.subFarmStore.deleteSubFarm(item);
      }
    });
  }

  private gridBuilder(): void {
    this.permissionPipe.transform(ApPermissions.EDIT_SUBFARMS).subscribe(permission => {
      this.columns = [
        new ApDynGridStatusColumnConfig({
          field: 'Status',
          showHeaderTitle: true,
          class: 'StatusClass',
          description: 'StatusDesc',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Nummer',
          title: 'Base__ManagementStyle_Number',
          filterable: true,
          width: 80,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Name',
          title: 'Global__Name',
          filterable: true,
          width: 100,
          headerFilterable: true,
          sortIndex: 0,
          sortDesc: false
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Street',
          title: 'Lbl_Order_Streetno',
          filterable: true,
          width: 80,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Postalcode',
          title: 'Global__ZipCode',
          filterable: true,
          width: 80,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.City',
          title: 'Global__City',
          filterable: true,
          width: 80,
          headerFilterable: true,
          hide: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Email',
          title: 'Global__Email',
          filterable: true,
          width: 80,
          headerFilterable: true,
          hide: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Telephone_Nr',
          title: 'Global__Telephon',
          filterable: true,
          width: 80,
          headerFilterable: true,
          hide: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Fax',
          title: 'Docu_Ini__Fax',
          filterable: true,
          width: 80,
          headerFilterable: true,
          hide: true
        }),
        new ApDynGridEditColumnConfig(
          {
            disabled: !permission,
          }
        )
      ];
      this.pager = new ApDynGridPagerConfig({
        listMassEditing: this._listMassEditing,
        hasPermission: permission,
      });
    });
  }

  private fillWizardChoiceData(): void {
    const deleteSubFarm = {
      id: 0,
      name: this.translationStore.FindTranslationForSelectedLanguage('Global__Delete'),
      type: ApGridPagerType.None,
      values: null,
      onSubmit: this._onDelete
    } as IWizardChoiceData;
    this._listMassEditing.push(deleteSubFarm);
  }
}
